import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgComponent = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 10.787 7.606 6.394 12 2l4.394 4.394zm5.606 5.607L13.213 12l4.393-4.394L22 12zm-11.212 0L2 12l4.394-4.394L10.787 12zM12 22l-4.394-4.394L12 13.213l4.394 4.393z"
      />
    </svg>
  );
};
export default SvgComponent;
